import { Box, Card, Typography, createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
import PlaceDistance from '../PlaceDistance';
import { availableSessionsLabel } from '../../utils/plural';
var useStyle = makeStyles(function (theme) {
    return createStyles({
        address: {
            color: theme.palette.grey[500],
            fontSize: theme.typography.body2.fontSize,
            fontWeight: 300,
        },
        distance: {
            color: theme.palette.grey[400],
            display: 'flex',
            fontSize: theme.typography.body2.fontSize,
            lineHeight: 1,
        },
        head: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        name: {
            fontSize: theme.typography.body1.fontSize,
            fontWeight: 'bold',
        },
        nbSessions: {
            color: theme.palette.primary.main,
            textAlign: 'right',
        },
        root: {
            boxShadow: theme.shadows[1],
            display: 'flex',
            flexDirection: 'column',
            height: 130,
            justifyContent: 'space-between',
            padding: theme.spacing(2),
        },
    });
});
export default (function (_a) {
    var id = _a.id, name = _a.name, distance = _a.distance, address = _a.address, nbSessions = _a.nbSessions, onSelect = _a.onSelect;
    var styles = useStyle({});
    var handleClick = function () {
        onSelect({ id: id, name: name, distance: distance, address: address, nbSessions: nbSessions });
    };
    return (React.createElement(Card, { className: styles.root, onClick: handleClick },
        React.createElement(Box, { className: styles.head },
            React.createElement(Box, { flexGrow: 1 },
                React.createElement(Typography, { className: styles.name }, name),
                React.createElement(Typography, { className: styles.address }, address)),
            distance && React.createElement(PlaceDistance, { distance: distance })),
        React.createElement(Typography, { className: styles.nbSessions }, availableSessionsLabel(nbSessions))));
});
//# sourceMappingURL=index.js.map